import React, { useState } from "react";
import styles from "./LastCommentBubble.module.scss";
import { getAnomaliesFacturation } from "../FlotteUtils";

/**
 * LS-742 : marqueur rouge sur la ligne d'un véhicule en anomalie de facturation, avec la
 * liste des causes au survol (mêmes styles que la bulle du dernier commentaire).
 * @param {Object} item - Le véhicule (avec `anomalies_facturation` renvoyé par l'API)
 * @returns {JSX.Element|null} Le marqueur ou null hors anomalie
 */
const AnomalieFacturationBubble = ({ item }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const causes = getAnomaliesFacturation(item);

  if (causes.length === 0) {
    return null;
  }

  return (
    <div className={styles.commentBubbleContainer}>
      <i
        className={`fas fa-exclamation-triangle text-danger ${styles.commentIcon}`}
        role="img"
        aria-label={`Anomalie de facturation : ${causes.join(", ")}`}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        title={["Anomalie de facturation", ...causes].join("\n")}
      />

      {showTooltip && (
        <div className={styles.tooltip}>
          <div className={styles.tooltipHeader}>
            <span className={styles.author} style={{ color: "#f8d7da" }}>
              Anomalie de facturation
            </span>
          </div>
          <ul className={`${styles.tooltipContent} mb-0 pl-3`}>
            {causes.map((cause) => (
              <li key={cause}>{cause}</li>
            ))}
          </ul>
          <div className={styles.tooltipArrow}></div>
        </div>
      )}
    </div>
  );
};

export default AnomalieFacturationBubble;
